import {
  ActionIcon,
  Avatar,
  Divider,
  Flex,
  SimpleGrid,
  Text,
  Title,
  Tooltip,
  useMantineTheme,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { ArrowRight, Profile, TickCircle } from "iconsax-react";
import {
  ComponentNewCardSpider,
  HeaderNewCardSpider,
  InfoTrade,
} from "../components";
import { IListProduct } from "../../../../interfaces/Products/IListProducts";
import { generateSlug } from "../../../../utils/cleanSlug";
import { client_selected } from "../../../../client";

type IProps = {
  item: IListProduct;
  preSlug?: string;
  purchase?: boolean;
};

export default function NewCardSpider({ item, preSlug, purchase }: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const displayedStart = !!item?.start_price
    ? item?.start_price
    : t("marketplace.card.free");

  const handleNavigate = () => {
    navigate({
      pathname: !!preSlug
        ? `${preSlug}${generateSlug(item.title)}&id=${item.id.toString()}`
        : `${generateSlug(item.title)}&id=${item.id.toString()}`,
    });
  };
  const isCopyTrading = item?.category === "CopyTrading";
  return (
    <ComponentNewCardSpider
      onClick={handleNavigate}
      image={item?.photo}
      title={item?.title}
      header={
        <>
          <Flex
            direction={"row"}
            p={"10px"}
            gap="8px"
            justify={"space-between"}
            align={"start"}
            w="100%"
            h="100%"
          >
            <HeaderNewCardSpider item={item} />
            <Flex
              direction={"column"}
              gap="4px"
              justify={"space-between"}
              h="100%"
            >
              <Avatar
                mt="17px"
                variant="outline"
                size={50}
                color="basic.2"
                radius={4}
                src={item?.icon}
                alt={!!item?.title ? item.title : "--"}
                styles={{
                  root: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: `1.5px solid ${theme.colors.basic[2]}`,
                  },
                  image: {
                    height: "50px",
                    width: "50px",
                  },
                }}
              >
                <Profile color={theme.colors.basic[5]} />
              </Avatar>
              <Flex w="100%" justify={"end"} h="48px">
                {purchase ? (
                  <Flex miw={{ base: "26px", 500: "43px" }}>
                    <Tooltip label="Assinado">
                      <TickCircle
                        size={43}
                        color={theme.colors.alerts[2]}
                        variant="Bold"
                      />
                    </Tooltip>
                  </Flex>
                ) : null}
              </Flex>
            </Flex>
          </Flex>
          {isCopyTrading ? (
            <SimpleGrid
              spacing={10}
              breakpoints={[
                { minWidth: 200, cols: 2 },
                { minWidth: 400, cols: 4 },
              ]}
            >
              <InfoTrade
                value={!!item?.release_date ? item?.release_date : "----"}
                label="marketplace.card.date_init"
              />
              <InfoTrade
                value={!!item?.profitability ? item?.profitability : "----"}
                label="marketplace.card.return_percent"
                color={
                  !!item?.profitability
                    ? item?.profitability.includes("-")
                      ? theme.colors.alerts[0]
                      : theme.colors.alerts[2]
                    : theme.colors.basic[2]
                }
              />
              <InfoTrade
                value={
                  !!item?.min_value_config ? item?.min_value_config : "----"
                }
                label="marketplace.card.min"
              />
              <InfoTrade
                value={!!item?.max_loss_daily ? item?.max_loss_daily : "----"}
                label="marketplace.card.max"
                color={theme.colors.alerts[0]}
              />
            </SimpleGrid>
          ) : null}
        </>
      }
    >
      <Flex direction={"column"} gap="10px" mih={"54px"} justify={"end"}>
        <Flex
          justify="space-between"
          align={"center"}
          w="100%"
          gap="8px"
          p="0 14px"
          h="54px"
        >
          <Flex
            fw={400}
            fz={16}
            w="100%"
            gap="6px"
            color="basic.5"
            style={{
              whiteSpace: "nowrap",
              wordBreak: "unset",
            }}
          >
            <Trans
              i18nKey="marketplace.card.value_start"
              values={{ value: displayedStart }}
              components={[
                <Title
                  key="value-title"
                  fw={600}
                  fz={{ base: 18 }}
                  color="primary.1"
                  w={"fit-content"}
                  style={{
                    marginLeft: "4px",
                  }}
                />,
                <Text key="bold" component="span" fw={700} />,
              ]}
            />
          </Flex>
          <ActionIcon
            w={{ base: 48, 991: 56 }}
            h={{ base: 40, 991: 44 }}
            radius="10px"
            variant="outline"
            style={{
              transition: "all 0.5s linear",
            }}
          >
            <ArrowRight
              size={28}
              style={{
                transition: "all 0.5s linear",
              }}
            />
          </ActionIcon>
        </Flex>
      </Flex>
    </ComponentNewCardSpider>
  );
}
